/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { useState } from 'react';

import { IoIosArrowBack } from 'react-icons/io';
import { useHistory } from 'react-router-dom';

import { Layout } from '~/components';

import {
  Header,
  HeaderWrapper,
  HeaderLabel,
  Sidebar,
  Container,
  Wrapper,
  RowContent,
  Content,
} from './styles';

export function ProfileCode() {
  const { goBack } = useHistory();

  const [selectedComponent, setSelectedComponent] = useState('gender');

  const sidebarList = [
    {
      value: 'gender',
      title: 'Sexo',
    },
    {
      value: 'level',
      title: 'Nível',
    },
    {
      value: 'physicalEvaluation',
      title: 'Avaliação Física',
    },
    {
      value: 'objective',
      title: 'Objetivo',
    },
    {
      value: 'frequency',
      title: 'Frequência',
    },
    {
      value: 'availableTime',
      title: 'Tempo disponível',
    },
  ];

  function Gender() {
    return (
      <>
        <RowContent>
          <p>Sem Info</p>
          <p>SX00</p>
        </RowContent>

        <RowContent>
          <p>Masculino</p>
          <p>SX01</p>
        </RowContent>

        <RowContent>
          <p>Feminino</p>
          <p>SX02</p>
        </RowContent>

        <RowContent>
          <p>Outros</p>
          <p>SX03</p>
        </RowContent>
      </>
    );
  }

  function Level() {
    return (
      <>
        <RowContent>
          <p>Sem Info</p>
          <p>NT00</p>
        </RowContent>

        <RowContent>
          <p>Sedentário</p>
          <p>NT01</p>
        </RowContent>

        <RowContent>
          <p>Iniciante</p>
          <p>NT02</p>
        </RowContent>

        <RowContent>
          <p>Intermediário</p>
          <p>NT03</p>
        </RowContent>

        <RowContent>
          <p>Avançado</p>
          <p>NT04</p>
        </RowContent>

        <RowContent>
          <p>Atleta</p>
          <p>NT05</p>
        </RowContent>
      </>
    );
  }

  function PhysicalEvaluation() {
    return (
      <>
        <RowContent>
          <p>Sem Info</p>
          <p>AV00</p>
        </RowContent>

        <RowContent>
          <p>baixo peso</p>
          <p>AV01</p>
        </RowContent>

        <RowContent>
          <p>peso normal</p>
          <p>AV02</p>
        </RowContent>

        <RowContent>
          <p>excesso do peso</p>
          <p>AV03</p>
        </RowContent>

        <RowContent>
          <p>obesidade 01</p>
          <p>AV04</p>
        </RowContent>

        <RowContent>
          <p>obesidade 02</p>
          <p>AV05</p>
        </RowContent>

        <RowContent>
          <p>obesidade 03</p>
          <p>AV06</p>
        </RowContent>
      </>
    );
  }

  function Objective() {
    return (
      <>
        <RowContent>
          <p>Sem info</p>
          <p>OT00</p>
        </RowContent>

        <RowContent>
          <p>condicionamento</p>
          <p>OT01</p>
        </RowContent>

        <RowContent>
          <p>emagrecimento</p>
          <p>OT02</p>
        </RowContent>

        <RowContent>
          <p>estética</p>
          <p>OT03</p>
        </RowContent>

        <RowContent>
          <p>hipertrofia</p>
          <p>OT04</p>
        </RowContent>

        <RowContent>
          <p>qualida de devida</p>
          <p>OT05</p>
        </RowContent>
      </>
    );
  }

  function Frequency() {
    return (
      <>
        <RowContent>
          <p>sem info</p>
          <p>FQ00</p>
        </RowContent>

        <RowContent>
          <p>1x</p>
          <p>FQ01</p>
        </RowContent>

        <RowContent>
          <p>2x</p>
          <p>FQ02</p>
        </RowContent>

        <RowContent>
          <p>3x</p>
          <p>FQ03</p>
        </RowContent>

        <RowContent>
          <p>4x</p>
          <p>FQ04</p>
        </RowContent>

        <RowContent>
          <p>5x</p>
          <p>FQ05</p>
        </RowContent>

        <RowContent>
          <p>6x</p>
          <p>FQ06</p>
        </RowContent>

        <RowContent>
          <p>7x</p>
          <p>FQ07</p>
        </RowContent>
      </>
    );
  }

  function AvailableTime() {
    return (
      <>
        <RowContent>
          <p>sem info</p>
          <p>TA00</p>
        </RowContent>

        <RowContent>
          <p>30 minutos</p>
          <p>TA01</p>
        </RowContent>

        <RowContent>
          <p>30-45 minutos</p>
          <p>TA02</p>
        </RowContent>

        <RowContent>
          <p>45-60 minutos</p>
          <p>TA03</p>
        </RowContent>

        <RowContent>
          <p>60-90 minutos</p>
          <p>TA04</p>
        </RowContent>

        <RowContent>
          <p>90 +</p>
          <p>TA05</p>
        </RowContent>
      </>
    );
  }

  const sidebarSelectedComponent: { [key: string]: JSX.Element } = {
    gender: <Gender />,
    level: <Level />,
    physicalEvaluation: <PhysicalEvaluation />,
    frequency: <Frequency />,
    availableTime: <AvailableTime />,
    objective: <Objective />,
  };

  return (
    <Layout title="Training - Store">
      <Container>
        <Sidebar>
          <ul>
            {sidebarList.map((item) => (
              <li
                key={item.value}
                onClick={() => setSelectedComponent(item.value)}
                className={selectedComponent === item.value ? 'active' : ''}
              >
                <p>{item.title}</p>
              </li>
            ))}
          </ul>
        </Sidebar>

        <Wrapper>
          <Header>
            <HeaderWrapper onClick={() => goBack()}>
              <IoIosArrowBack color="#FFDF22" size={24} />

              <HeaderLabel>ProfileCode</HeaderLabel>
            </HeaderWrapper>
          </Header>

          <Content>{sidebarSelectedComponent[selectedComponent]}</Content>
        </Wrapper>
      </Container>
    </Layout>
  );
}
